import React from 'react'
import type {ContractBufferExceptionEvidence} from '../core/_models'

export const DOCUMENT_EXPIRY_EXCEPTION_SCOPE = 'All document expiry checks waived:\n'

export const ContractExceptionDetails: React.FC<{evidence: ContractBufferExceptionEvidence; showAllowedBy?: boolean}> = ({evidence, showAllowedBy}) => {
  if (!evidence.contractBufferException) return null
  return (
    <section className='mb-3' aria-label='Saved exception remarks'>
      {showAllowedBy && <>
        <strong>Allowed by</strong>
        <p>{evidence.contractBufferExceptionBy || '—'}</p>
      </>}
      <strong>Remarks</strong>
      <p className='mb-0' style={{whiteSpace: 'pre-wrap'}}>{evidence.contractBufferExceptionReason || '—'}</p>
    </section>
  )
}

export const ContractExceptionFields: React.FC<{
  checked: boolean
  reason: string
  onChecked: (value: boolean) => void
  onReason: (value: string) => void
  disabled?: boolean
}> = ({checked, reason, onChecked, onReason, disabled}) => (
  <fieldset className='col-12 mt-3 mb-3' disabled={disabled}>
    <legend className='fs-6'>Document expiry exception</legend>
    <label className='d-flex align-items-center gap-2'>
      <input type='checkbox' checked={checked} onChange={e => onChecked(e.target.checked)} />
      Bypass document expiry checks for all documents
    </label>
    <p className='text-muted small mb-2'>
      Allows sign-on and assignment updates regardless of document expiry dates. Saved expiry dates
      are not changed. Remarks are required.
    </p>
    {checked && (
      <label className='d-block'>
        Exception remarks (required, maximum 1000 characters)
        <textarea className='form-control' value={reason} maxLength={1000} required
          onChange={e => onReason(e.target.value)} rows={3} />
      </label>
    )}
  </fieldset>
)
